jQuery(document).ready(function ($) {

/* -----------------------------
    MAIN PRODUCT GALLERY SLIDER
------------------------------ */
$('.product-gallery-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false,
    fade: false,
    adaptiveHeight: true,
    asNavFor: '.product-gallery-nav',
    prevArrow:
    '<button type="button" class="slick-prev"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.125 16.875C13.2849 16.875 13.4449 16.8139 13.5669 16.6919C13.8111 16.4476 13.8111 16.0522 13.5669 15.8081L7.75877 9.99998L13.5669 4.19186C13.8111 3.94764 13.8111 3.55217 13.5669 3.30811C13.3227 3.06404 12.9272 3.06389 12.6831 3.30811L6.43315 9.55811C6.18893 9.80232 6.18893 10.1978 6.43315 10.4419L12.6831 16.6919C12.8052 16.8139 12.9652 16.875 13.125 16.875Z" fill="#1E1E1E"/></svg></button>',
    nextArrow:
    '<button type="button" class="slick-next"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.87498 16.875C6.71513 16.875 6.55513 16.8139 6.4331 16.6919C6.18888 16.4476 6.18888 16.0522 6.4331 15.8081L12.2412 9.99998L6.4331 4.19186C6.18888 3.94764 6.18888 3.55217 6.4331 3.30811C6.67732 3.06404 7.07279 3.06389 7.31685 3.30811L13.5669 9.55811C13.8111 9.80232 13.8111 10.1978 13.5669 10.4419L7.31685 16.6919C7.19482 16.8139 7.03482 16.875 6.87498 16.875Z" fill="#1E1E1E"/></svg></button>',
});

/* -----------------------------
    THUMBNAIL NAV SLIDER
------------------------------ */
$('.product-gallery-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.product-gallery-for',
    focusOnSelect: true,
    infinite: false,
    arrows: false,
    dots: false,
    variableWidth: false,
    centerMode: false,
    // 👉 Make it vertical
    vertical: true,
    verticalSwiping: true,
});

/* -----------------------------
    THUMBNAIL CLICK → GO TO SLIDE
    (supports your Liquid "data-target" system)
------------------------------ */
$('.product-gallery-nav .slick--slide').on('click', function () {
    const targetId = $(this).data('target');
    const slideIndex = $(`#${targetId}`).data('slide-id');

    if (slideIndex) {
    $('.product-gallery-for').slick('slickGoTo', slideIndex - 1);
    }
});

/* -----------------------------
    SLICK LIGHTBOX (ZOOM POPUP)
    Uses .zooom element inside slide
------------------------------ */
$('.product-gallery-for').each(function () {
    var sLightbox = $(this);
    sLightbox.slickLightbox({
    itemSelector: '.slick--slide .zooom',   // your zoom icon wrapper
    src: 'src',                             // extract from div[src=""]
    navigateByKeyboard: true,
    caption: false,
    background: 'rgba(0,0,0,0.9)'
    });
});

});


$('.collection-circles__flex').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    infinite: false,
    arrows: false,
    dots: true,
    centerMode: false,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
        {
        breakpoint: 1240,
        settings: {
            slidesToShow: 5
        }
        },
        {
        breakpoint: 992,
        settings: {
            slidesToShow: 4
        }
        },
        {
        breakpoint: 768,
        settings: {
            slidesToShow: 3
        }
        },
        {
        breakpoint: 480,
        settings: {
            slidesToShow: 2
        }
        }
    ]
});

function initMobileSlider() {
    if ($(window).width() <= 768) {
        if (!$('.activities-flex').hasClass('slick-initialized')) {
            $('.activities-flex').slick({
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: false,
                arrows: false,
                dots: true,
                autoplay: true,
                autoplaySpeed: 2000,
                responsive: [
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 2
                        }
                    }
                ]
            });
        }
    } else {
        if ($('.activities-flex').hasClass('slick-initialized')) {
            $('.activities-flex').slick('unslick');
        }
    }
}

// Run on load
$(document).ready(function () {
    initMobileSlider();
});

// Run on resize
$(window).on('resize', function () {
    initMobileSlider();
});